import { Component, HostListener, OnDestroy, OnInit,inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NavigationEnd, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { LoginapiService } from 'src/app/Apicalls/LoginApicall/loginapi.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'Suvi';
  cookieService = inject(CookieService);
  private inactivityTimeout: any;
  private readonly INACTIVITY_LIMIT = 15 * 60 * 1000; // 15 minutes in ms
  constructor(private router: Router, public snackBar: MatSnackBar,    readonly apiCallsService: LoginapiService,
  ) {}

  ngOnInit(): void {
  // Check token on initialization to ensure user stays logged in across sessions
    this.handleToken();
    this.setupInactivityTimer();
  }
  handleToken(): void {
    const token = localStorage.getItem('user'); // token persists across sessions
    if (token) {
      try {
        const tokenPayload = token.split('.')[1]; // Extract the payload
        const decodedPayload = atob(tokenPayload);
        const decodedPayloadJson = JSON.parse(decodedPayload);
        // const expirationTime = decodedPayloadJson.exp; // Expiration time from the token
        const currentTime = Math.floor(Date.now() / 1000);

        // If token is expired, log the user out
        // if (currentTime >= expirationTime) {
        //   this.logout();
        //   setTimeout(() => {
        //     this.openSnackBar();
        //     setTimeout(() => {
        //       window.location.reload();
        //     }, 500);
        //   }, 100);
        // } else {
        //   // If token is still valid, set a timeout to log out the user when it expires
        //   const timeUntilLogout = expirationTime - currentTime;
        //   setTimeout(() => {
        //     this.logout();
        //     this.openSnackBar();
        //     setTimeout(() => {
        //       window.location.reload();
        //     }, 1000);
        //   }, timeUntilLogout * 1000); // Automatically logout at expiration time
        // }
      } catch (error) {
        console.error('Error decoding token:', error);
        this.logout();
      }
    }
  }

  setupInactivityTimer() {
    const resetTimer = () => {
      if (this.inactivityTimeout) {
        clearTimeout(this.inactivityTimeout);
      }
      this.inactivityTimeout = setTimeout(() => {
        this.logout();
        this.openSnackBar();
      }, this.INACTIVITY_LIMIT);
    };
    // Listen for user activity
    window.addEventListener('mousemove', resetTimer);
    window.addEventListener('keydown', resetTimer);
    window.addEventListener('mousedown', resetTimer);
    window.addEventListener('touchstart', resetTimer);
    window.addEventListener('scroll', resetTimer);
    resetTimer(); // Start timer on load
  }

  ngOnDestroy(): void {
    // Any cleanup logic if needed
    if (this.inactivityTimeout) {
      clearTimeout(this.inactivityTimeout);
    }
    window.removeEventListener('mousemove', this.setupInactivityTimer);
    window.removeEventListener('keydown', this.setupInactivityTimer);
    window.removeEventListener('mousedown', this.setupInactivityTimer);
    window.removeEventListener('touchstart', this.setupInactivityTimer);
    window.removeEventListener('scroll', this.setupInactivityTimer);
  }

  openSnackBar(): void {
    this.snackBar.open('Session Timeout', '', {
      duration: 2000,
    });
  }

  logout(): void {
    // Call the logout API
    const logoutMessage = { message: 'User logged out' };
    this.apiCallsService.logout(logoutMessage).subscribe({
      next: (response) => {
        // Broadcast a global logout event so all components can clean up
        window.dispatchEvent(new Event('app-logout'));
        // ...existing code...
        // Clear local storage
        localStorage.clear();
        // Clear session storage
        sessionStorage.clear();
        // Clear cookie 
        this.cookieService.delete('vicas_token');
        // Navigate to the login page
        this.router.navigate(['/login']);
        window.location.reload();
      },
      error: (error) => {
        console.error('Error during logout:', error);
        // Removed alert to avoid unnecessary message on inactivity logout
      },
    });
  }
}
